import { useEffect } from 'react';
import { searchShows } from '../../../../../play-core/api/show-search/search-shows';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { useAxios } from '../../../hooks/use-axios';
import { useSearchDispatch, useSearchState } from '../SearchContext';
export const useShowSearch = () => {
  const state = useSearchState();
  const dispatch = useSearchDispatch();
  const axios = useAxios();
  const {
    search: config
  } = useVideoConfig();
  useEffect(() => {
    let isSubscribed = true;
    const loadSearchResults = async () => {
      try {
        if (config.showSearchSupported && state.query.searchTerm.length > 0) {
          dispatch({
            type: 'search-shows'
          });
          const result = await searchShows(axios, state.query.searchTerm, 'VIDEO');
          isSubscribed && dispatch({
            type: 'search-shows-success',
            result
          });
        }
      } catch {
        isSubscribed && dispatch({
          type: 'search-shows-failed'
        });
      }
    };
    loadSearchResults();
    return () => {
      isSubscribed = false;
    };
  }, [state.query.searchTerm, dispatch, axios, config]);
};